const cmHomeRouter = [
  {
    path: 'designPage',
    name: 'CM-home-designPage',
    component: () => import('@/views/wxapp/customer-manager/home/designPage'),
    meta: {
      title: '销售服务流程'
    }
  },
  {
    path: 'ceshiList',
    name: 'ceshiList',
    component: () => import('@/views/wxapp/customer-manager/list'),
    meta: {
      title: '测试啊'
    }
  }
]
export default cmHomeRouter
